import { useMemo } from 'react';

import { Kit } from '@repo/types';

import { usePortalConfigs } from './usePortalConfigs';

export type ActivationStepKey = 'activate' | 'collect' | 'forms';

export type ActivationStep = {
  key: ActivationStepKey;
  label: string;
};

const STEP_LABELS: Record<ActivationStepKey, string> = {
  activate: 'Activate your kit',
  collect: 'Collect & mail sample',
  forms: 'Complete health forms',
};

export const useActivationSteps = (
  kit?: Partial<Kit> | null,
): ActivationStep[] => {
  const { config } = usePortalConfigs(kit as Kit | null | undefined);
  const surveyType = config.survey_type ?? 'full';

  return useMemo(() => {
    const keys: ActivationStepKey[] = ['activate', 'collect'];
    if (surveyType !== 'skip') keys.push('forms');
    return keys.map(key => ({ key, label: STEP_LABELS[key] }));
  }, [surveyType]);
};
